// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"73f159eb","799":"73f159eb","6667":"cdf79367"}[chunkId] + ".chunk.css";
};